/*!
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
type PopupOptions = {
  widthRatio?: number;
  heightRatio?: number;
  center?: boolean;
  resizable?: boolean;
  scrollbars?: boolean;
  left?: number;
  top?: number;
};

export const isAndroid = () => {
  const ua = navigator.userAgent || "";
  return /Android/i.test(ua);
};

export const isSafariBrowser = () => {
  const ua = navigator.userAgent;
  return /^((?!chrome|android).)*safari/i.test(ua);
};

export const isChrome = () => {
  const ua = navigator.userAgent || "";
  return /Chrome/i.test(ua);
};

export const isIOSChrome = () => {
  const ua = navigator.userAgent || "";
  return /CriOS/i.test(ua);
};

export const isIPhone = () => {
  const ua = navigator.userAgent || "";
  // Detect iPhone
  return /iPhone/.test(ua);
};

export const isSamsungBrowser = () => {
  const ua = navigator.userAgent || "";
  return /SamsungBrowser/i.test(ua);
};

export const buildPopupFeatures = (options: PopupOptions = {}): string => {
  const {
    widthRatio = 0.9,
    heightRatio = 0.9,
    center = false,
    resizable = true,
    scrollbars = true,
    left,
    top,
  } = options;

  const width = Math.floor(window.screen.width * widthRatio);
  const height = Math.floor(window.screen.height * heightRatio);

  const finalLeft =
    left ?? (center ? Math.floor((window.screen.width - width) / 2) : 0);

  const finalTop =
    top ?? (center ? Math.floor((window.screen.height - height) / 2) : 0);

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${finalLeft}`,
    `top=${finalTop}`,
    `resizable=${resizable ? "yes" : "no"}`,
    `scrollbars=${scrollbars ? "yes" : "no"}`,
  ];

  return features.join(",");
};
